export default __webpack_public_path__ + "static/media/2104.f4223f43.png";